import { ENTERPRISE_IMAGE_PATH } from '../../theme';
import { TEXT_COLOR } from '../../theme';
import ShareIcon from '@mui/icons-material/Share';
import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { isEnterprise } from '../../theme';
import { IconButton, MenuItem, Typography } from '@mui/material';
import logo from '../../components/ResponsiveNavbar/logo.png';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Link as MuiLink } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { mobileDrawerStyles } from './styles';
import { MobileScreenLogoContainer } from '../../pages/Tracks/styles';
import { UserDetailsContextInterface } from '../../contexts';
import { UserDetailsContext } from '../../contexts';
import { formatFileSize } from '../../services/trackService';
import { BorderLinearProgress } from '../StorageComponent/styles';
import { Role } from '../../proto/api_pb';
import { tierStorageMap } from '../../pages/Billing/types';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import GroupIcon from '@mui/icons-material/Group';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import { photo } from '../SingleProject/types';
import { styles } from '../TracksPageComponents/styles';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Mixpanel from '../../utils/mixpanel';

export const MobileDrawer: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const { enterprises } = React.useContext<UserDetailsContextInterface>(UserDetailsContext);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const { storageUsage, subscriptionTier } = React.useContext(UserDetailsContext);
  const [totalStorage, setTotalStorage] = React.useState(0);
  const { userName } = React.useContext(UserDetailsContext);
  const { isEnterpriseAccount, enterprise } =
    React.useContext<UserDetailsContextInterface>(UserDetailsContext);

  React.useEffect(() => {
    if (subscriptionTier) setTotalStorage(tierStorageMap[subscriptionTier].storageValue);
  }, [subscriptionTier, storageUsage]);

  const DrawerList = (
    <Box sx={{ width: '80vw', display: 'flex' }} role="presentation" onClick={toggleDrawer(false)}>
      <Box sx={{ width: '15vw' }}>
        <Box sx={mobileDrawerStyles.closeButtonContainer}>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Box sx={mobileDrawerStyles.outerContainer}>
        <Box>
          <Box sx={{ padding: '15px', paddingBottom: '5px' }}>
            {isEnterpriseAccount && (
              <Box sx={{ marginBottom: '10px' }}>
                {enterprise?.image && (
                  <img
                    style={{
                      width: '60px',
                      height: '50px',
                    }}
                    src={enterprise.image.includes('http') ? enterprise.image : photo}
                    alt=""
                  />
                )}
              </Box>
            )}
            <Box
              sx={
                isEnterpriseAccount
                  ? {
                      display: 'flex',
                      justifyContent: isEnterpriseAccount ? 'space-between' : 'flex-start',
                      alignItems: 'center',
                      backgroundColor: '#1F242F',
                      padding: '5px',
                      borderRadius: '7px',
                    }
                  : styles.logoContainer
              }
            >
              {isEnterpriseAccount && (
                <Typography sx={{ fontWeight: 'bold' }}>Powered by</Typography>
              )}
              <Link to="/my-tracks">
                <img
                  style={{ width: '110px', height: '30px' }}
                  className="logo-image"
                  src={isEnterprise ? ENTERPRISE_IMAGE_PATH : logo}
                  alt="logo"
                />
              </Link>
            </Box>
          </Box>
          <hr />
          {isEnterpriseAccount && (
            <MenuItem onClick={() => navigate('/dashboard')}>
              <HomeOutlinedIcon sx={{ margin: '2px', marginRight: '8px' }} />
              Dashboard
            </MenuItem>
          )}
          <MenuItem onClick={() => navigate('/user-profile/' + userName)}>
            <AccountCircleOutlinedIcon sx={{ fontSize: '25px', filter: 'contrast(30%)' }} />
            <Typography sx={{ marginLeft: '10px' }}>Profile</Typography>
          </MenuItem>
          {isEnterpriseAccount && (
            <MenuItem onClick={() => navigate('/projects')}>
              <MusicNoteIcon sx={{ margin: '2px', marginRight: '8px' }} />
              Projects
            </MenuItem>
          )}
          {isEnterpriseAccount && (
            <MenuItem onClick={() => navigate('/team-management')}>
              <GroupIcon sx={{ margin: '2px', marginRight: '8px' }} />
              Team Management
            </MenuItem>
          )}
          <MenuItem onClick={() => navigate('/share-management')}>
            <ShareIcon sx={{ fontSize: '25px', filter: 'contrast(30%)' }} />
            <Typography sx={{ marginLeft: '10px' }}>Shared Tracks</Typography>
          </MenuItem>
          {!isEnterpriseAccount || Number(enterprise?.role) === Role.ROLE_ADMIN ? (
            <MenuItem onClick={() => navigate('/billing')}>
              <img
                style={{ filter: 'contrast(30%)' }}
                src="/assets/icons/TracksPageIcons/receipt.svg"
                alt=""
              />
              <Typography sx={{ marginLeft: '10px' }}>Billing</Typography>
            </MenuItem>
          ) : null}
          <MuiLink sx={{ textDecoration: 'none' }} href="mailto:hello@ommuse.com">
            <MenuItem>
              <img
                style={{ filter: 'contrast(30%)' }}
                src="/assets/icons/TracksPageIcons/life-buoy-01.svg"
                alt="icon"
              />
              <Typography sx={{ marginLeft: '10px', color: TEXT_COLOR }}>Support</Typography>
            </MenuItem>
          </MuiLink>
          {(!isEnterpriseAccount ||
            (enterprise && Number(enterprise.role) !== Role.ROLE_ARTIST)) && (
            <Box>
              <Box sx={mobileDrawerStyles.storageDetailsContainer}>
                <Box sx={mobileDrawerStyles.cloudIconContainer}>
                  <img
                    style={{ width: '20px', height: '20px' }}
                    src="/assets/icons/TracksPageIcons/cloud-blank-01.svg"
                    alt=""
                  />
                </Box>
                <Box sx={{ width: '80%' }}>
                  <Typography sx={{ fontSize: '14px' }}>{`${formatFileSize(
                    storageUsage
                  )} of ${formatFileSize(totalStorage)} used`}</Typography>

                  <BorderLinearProgress
                    variant="determinate"
                    value={Math.min((storageUsage / totalStorage) * 100, 100)}
                    sx={{ marginTop: 1 }}
                  />
                </Box>
              </Box>
            </Box>
          )}
        </Box>
        <Box sx={{ marginBottom: '10px' }}>
          {enterprises.length > 1 && (
            <MenuItem
              onClick={() => {
                sessionStorage.clear();
                window.location.href = '/select-enterprise';
              }}
            >
              <PublishedWithChangesIcon sx={{ margin: '2px', marginRight: '8px' }} />
              Switch Account
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              logout({
                logoutParams: {
                  returnTo: window.location.origin + '/logout',
                },
              });
              sessionStorage.clear();
              Mixpanel.reset();
            }}
          >
            <img
              style={{ filter: 'contrast(30%)' }}
              src="/assets/icons/TracksPageIcons/log-out-02.svg"
              alt=""
            />
            <Typography sx={{ marginLeft: '10px' }}>Logout</Typography>
          </MenuItem>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <MobileScreenLogoContainer>
        <div>
          <Button onClick={toggleDrawer(true)}>
            <MenuIcon />
          </Button>
          <Drawer open={open} onClose={toggleDrawer(false)}>
            {DrawerList}
          </Drawer>
        </div>
        <img
          style={mobileDrawerStyles.img}
          className="logo-image"
          src={isEnterprise ? ENTERPRISE_IMAGE_PATH : logo}
          alt="logo"
        />
      </MobileScreenLogoContainer>
    </>
  );
};